// extracted by mini-css-extract-plugin
export default {"defaultButton":"button_defaultButton__FNit9","successButton":"button_successButton__jvF76","dangerButton":"button_dangerButton__V0gsF","orangeButton":"button_orangeButton__JT2gG"};